
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/krepselis",
      function () {
        return require("private-next-pages/lt/krepselis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/krepselis"])
      });
    }
  